export default __webpack_public_path__ + "static/media/stands_ind_TCI.1cdca173.jpg";